// File Metadata:
// Filename: QualityDashboard.js
// Version: 1.00
// Created: 2025-03-23 01:02:42
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { Paper, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2' // Import Grid v2
import { useGetReceptionsQuery } from '../../api/receptionsApiSlice'
import { useUpdateFieldMutation } from '../../../app/api/apiSlice'
import useAuth from '../../../hooks/useAuth'
import PendingApprovals from './PendingApprovals'
import QualityMetrics from './QualityMetrics'
import RecentDecisions from './RecentDecisions'

const QualityDashboard = () => {
    const { isQuality, isManager, isAdmin } = useAuth()
    //const [ updateField, { isLoading }] = useUpdateFieldMutation();
    const {
        data: receptions,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetReceptionsQuery('receptionsList')

    if (isLoading) return <div>Loading...</div>
    if (isError) return <div>Error: {error.message}</div>



    return (
        <Grid container spacing={3}>
            <Grid xs={12} md={6}>
                <Paper sx={{ p: 2, height: '100%' }}>
                    <Typography variant="h6">Pending Approvals</Typography>
                    <PendingApprovals receptions={receptions} />
                </Paper>
            </Grid>
            <Grid xs={12} md={6}>
                <Paper sx={{ p: 2, height: '100%' }}>
                    <Typography variant="h6">Quality Metrics</Typography>
                    <QualityMetrics receptions={receptions} />
                </Paper>
            </Grid>
            <Grid xs={12}>
                <Paper sx={{ p: 2 }}>
                    <Typography variant="h6">Recent Decisions</Typography>
                    <RecentDecisions receptions={receptions} />
                </Paper>
            </Grid>
        </Grid>
    )
}

export default QualityDashboard
